import { render, staticRenderFns } from "./MainSnackbar.vue?vue&type=template&id=36ad13d0&"
import script from "./MainSnackbar.vue?vue&type=script&lang=js&"
export * from "./MainSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MainSnackbar.vue"
export default component.exports